<template>
	<div class="insure_number_check">
		<el-card class="insure_number_content" header="校验工号">
			<el-alert :closable="false" title="为了确保您后续业绩统计正确，请确认您的出单工号！" type="warning"></el-alert>
			<div style="margin-top: 15px">
				<avue-form v-model="InsureNumberData" :option="InsureNumberOption" @submit="onInsureNumber"></avue-form>
			</div>
		</el-card>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {getUserInfo} from '@/api/login'

export default {
	name: 'dialogInsureNumber',
	mixins: [],
	components: {},
	props: {
		visible: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			InsureNumberOption: {
				submitText: '已确认',
				emptyBtn: false,
				// emptyText: '取消投保',
				enter: true,
				column: [
					{
						label: '工号',
						prop: 'number',
						labelWidth: '60',
						span: 16,
						rules: [
							{
								required: true,
								message: '请输入 工号',
								trigger: 'blur',
							},
						],
					},
				],
			},
			InsureNumberData: {
				number: '',
			},
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		'InsureNumberData.number': {
			handler(valNew, valOld) {
				if (valOld !== valNew) {
					this.InsureNumberData = {number: valNew.toUpperCase()}
				}
			},
		},
	},
	methods: {
		onInsureNumber(form, done) {
			//获取用户信息
			getUserInfo()
				.then((response) => {
					let resultData = response.data.data
					let {
						sysUser: {
							distAccount: {number = ''},
						},
					} = resultData
					if (this.validatenull(number)) {
						this.$message.error('获取用户数据有误！')
						return
					}
					if (number !== form.number) {
						this.$alert(
							'工号校验不通过，请确认输入的工号是否正确。如果工号确为本人的工号，请联系新市民业务人员进行工号变更后再进行投保！',
							'提示',
						).then(() => {})
						return
					}
					if (number === form.number) {
						this.$message.success('工号校验通过！')
						this.$emit('update:visible', false)
					}
				})
				.finally(() => {
					done()
				})
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
	padding: 20px 20px 0;
}

.insure_number_check {
	display: flex;
	justify-content: center;
	position: fixed;
	z-index: 10000;
	bottom: 0;
	right: 0;
	width: calc(100% - 170px);
	height: calc(100vh - 105px);
	background: rgba(0, 0, 0, 0.4);
	border-radius: 10px 10px 0 0;
}

.insure_number_content {
	margin-top: 25vh;
	margin-right: 170px;
	width: 32vw;
	height: 270px;
}
</style>
